import styled from 'styled-components'

// styles
import { WrapItem } from '../../../MerchantDetails/ListStores/StoreItem/index.styles';


const WrapDeviceItemByList = styled(WrapItem)`
    &:hover {
        .wrap-status {
            .wrap-device-infos {
                display: block;
            }
        }
    }
    
    .wrap-status {
        position: relative;
        justify-self: flex-start;
        & > .status {
            width: 22px;
            height: 22px;
            background: ${props => props.colorStatus};
        }

        .wrap-device-infos {
            position: absolute;
            top: 50%;
            left: calc(100% + 8px);
            display: none;
            z-index: 1;
        }
    }
    .image-merchant{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        img{
            height: 100%;
            border-radius: 50%;
        }
    }
`;

export {
    WrapDeviceItemByList
}